/**
 * Versioned schema changes for the code-navigation cache SQLite DB (file index + symbol index).
 */

import type { Database } from 'node-sqlite3-wasm';
import { readCodeNavCacheMigrationSql } from '../read-migration-sql.js';
import { runSqliteMigrations, type SqliteMigration } from '../run-sqlite-migrations.js';

export type CodeNavCacheSqliteMigration = SqliteMigration;

const CHECKPOINT_V1 = '001_code_nav_cache_checkpoint_v1';
const CHECKPOINT_V1_SQL = readCodeNavCacheMigrationSql('001_code_nav_cache_checkpoint_v1.sql');
const MIGRATION_002 = '002_content_hash_symbol_index';
const MIGRATION_002_SQL = readCodeNavCacheMigrationSql('002_content_hash_symbol_index.sql');
const MIGRATION_003 = '003_content_hash_tag_rows';
const MIGRATION_003_SQL = readCodeNavCacheMigrationSql('003_content_hash_tag_rows.sql');

export const CODE_NAV_CACHE_SQLITE_MIGRATIONS: CodeNavCacheSqliteMigration[] = [
  {
    name: CHECKPOINT_V1,
    checkpoint: true,
    migrate: (db) => {
      db.exec(CHECKPOINT_V1_SQL);
    },
    alreadyApplied: (db) => {
      const row = db.get(
        `SELECT 1 as ok FROM sqlite_master WHERE type='table' AND name='file_index_parent_path' LIMIT 1`,
      ) as { ok: number } | null;
      return row != null;
    },
  },
  {
    name: MIGRATION_002,
    migrate: (db) => {
      db.exec(MIGRATION_002_SQL);
    },
    alreadyApplied: (db) => {
      const row = db.get(
        `SELECT 1 as ok FROM sqlite_master WHERE type='table' AND name='symbol_file_blob' LIMIT 1`,
      ) as { ok: number } | null;
      return row != null;
    },
  },
  {
    name: MIGRATION_003,
    migrate: (db) => {
      db.exec(MIGRATION_003_SQL);
    },
    alreadyApplied: (db) => {
      const row = db.get(
        `SELECT 1 as ok FROM sqlite_master WHERE type='table' AND name='symbol_index_tag' LIMIT 1`,
      ) as { ok: number } | null;
      if (row == null) return false;
      const blob = db.get(
        `SELECT 1 as ok FROM sqlite_master WHERE type='table' AND name='symbol_file_blob' LIMIT 1`,
      ) as { ok: number } | null;
      return blob == null;
    },
  },
];

export function migrateCodeNavCacheSqlite(db: Database): void {
  runSqliteMigrations(
    db,
    CODE_NAV_CACHE_SQLITE_MIGRATIONS,
    readCodeNavCacheMigrationSql('000_bootstrap_migrations_table.sql'),
    'code-nav-cache',
  );
}
